// @core/api/endpoints/project/update_milestone.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  MilestoneResponse,
  UpdateMilestoneRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Update milestone
 * Updates milestone properties including name, description, and due date.
 */
export async function UpdateMilestone(
  project_id: string,
  milestone_id: string,
  data: UpdateMilestoneRequest,
  options?: RequestOptions
): Promise<MilestoneResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/milestones/:milestone_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':milestone_id', encodeURIComponent(milestone_id));
  const requestOptions = options;
  return client.put<MilestoneResponse>(requestPath, data, requestOptions);
}
